import { z } from "zod";

export const cupInfoSchema = z.object({
	title: z.string(),
	pic: z.string(),
	detail_text: z.string(),
});

export type CupInfoType = z.infer<typeof cupInfoSchema>;
